import { compositionIds } from "./composition-ids";
import { CompositionDetails } from "./composition-types";
import { aiseLaalanPayo } from "./library/aise-laalan-payo";
import { hePraanMaithili } from "./library/he-praan-maithili";
import { jagatJalanda } from "./library/jagat-jalanda";
import { mainBinGurDekhe } from "./library/main-bin-gur-dekhe";
import { mayeeSantSang } from "./library/mayee-sant-sang";
import { mereLaalanSimrit } from "./library/mere-laalan-simrit";
import { prabhMoheKabGal } from "./library/prabh-mohe-kab-gal";

export const compositions: { [key: string]: CompositionDetails } = {
    [compositionIds.aiseLaalanPayo]: aiseLaalanPayo,
    [compositionIds.mayeeSantSang]: mayeeSantSang,
    [compositionIds.mereLaalanSimrit]: mereLaalanSimrit,
    [compositionIds.hePraanMaithili]: hePraanMaithili,
    [compositionIds.prabhMoheKabGal]: prabhMoheKabGal,
    [compositionIds.mainBinGurDekhe]: mainBinGurDekhe,
    [compositionIds.jagatJalanda]: jagatJalanda,
};
